import React, { useEffect, useState } from 'react'
import './HealthInfo.scss'
import { ModalWrapper } from 'Components'
import AddIcon from 'Assets/Icons/add.png'
import HealthUpdate from './Modals/HealthUpdate/HealthUpdate'
import Swal from 'sweetalert2'
import profileService from 'Services/profileService'
import { EmployeeSingleType } from 'Models/employeeType'
import { AgeFormmatter } from 'Helpers/AgeFormatter'
import { AgeValidator } from 'Helpers/AgeValidator'

type DependentType = {
  fullName: string
  relationship: string
  dateOfBirth: string
  phoneNumber: string
  email: string
  address?: string
}

type Props = {
  profile: EmployeeSingleType | null | undefined
  setProfile: any
}

const HealthInfo = ({ profile }: Props) => {
  const [showModal, setShowModal] = useState(false)
  const toggleModal = () => {
    setShowModal((prevState) => !prevState)
  }

  const getDependents = (profile: any): DependentType[] => {
    return profile?.dependents || []
  }

  const [editingIndex, setEditingIndex] = useState(null)
  const [selectedHealth, setSelectedHealth] = useState<DependentType | null>(null)
  const [health, setHealth] = useState<DependentType[]>(() => getDependents(profile))

  useEffect(() => {
    setHealth(getDependents(profile))
  }, [profile])

  const handleAdd = (e: React.FormEvent<HTMLButtonElement>) => {
    e.preventDefault()
    setEditingIndex(null)
    setSelectedHealth(null)
    toggleModal()
  }

  // const handleEdit = (index: any) => {
  //   setEditingIndex(index)
  //   setSelectedHealth(health[index])

  //   toggleModal()
  // }

  const handleSaveRef = async (data: DependentType) => {
    const formatted = {
      fullName: data.fullName,
      relationship: data.relationship,
      dateOfBirth: data.dateOfBirth,
      phoneNumber: data.phoneNumber,
      email: data.email,
      // address: data.address,
    }

    const updatedEducation =
      editingIndex !== null
        ? health.map((item, i) => (i === editingIndex ? formatted : item))
        : [...health, formatted]

    await profileService
      .updateProfileV2({
        dependents: updatedEducation,
      })
      .then((res: any) => {
        // setRequest(false)

        if (res.data.status === true) {
          Swal.fire({
            text: 'Dependent information updated successfully',
            icon: 'success',
            confirmButtonText: 'Ok',
          })

          setHealth(updatedEducation)
          // refetchProfile()
        } else {
          Swal.fire({
            title: 'Oops!',
            text: 'Something went wrong!',
            icon: 'warning',
            confirmButtonText: 'Close',
          })
        }
      })
      .catch((error: any) => {
        // setRequest(false)

        Swal.fire({
          title: 'Oops!',
          text: error?.response?.data?.error || 'Something went wrong',
          icon: 'warning',
          confirmButtonText: 'Close',
        })
      })
  }

  return (
    <div className='health-info'>
      <div className='container-fluid mt-4 p-0 statutory'>
        <div className='row g-4'>
          <div className='col-lg-12 d-flex flex-column gap-4'>
            <form>
              <div className='card'>
                <div className='card-body mt-2'>
                  <div className='bank-details-h line d-flex justify-content-between align-items-center'>
                    <h6 className='heading'>HMO Information</h6>
                    <button onClick={handleAdd} className='reset-btn-as-link d-none'>
                      <img src={AddIcon} alt='icon' />
                    </button>
                  </div>

                  <div className='first-section-con line pb-3'>
                    <p className='text-muted pt-4 pb-'>
                      Employee&apos;s can add up to 5 legal dependents eligible for health coverage
                      (spouse and kids only).
                    </p>

                    <div className='first-row-con d-flex align-items-center'>
                      <div className=''>
                        <div className='first-row d-flex gap-3 d-none'>
                          <span>HMO Status</span>
                          <div className='active-con d-flex align-items-center gap-1'>
                            <div className='active-dot'></div>
                            <div className='status'>Enrolled</div>
                          </div>
                        </div>
                        <div className='second-row pt-2 d-none'>
                          <span>Last updated on</span> <span>___</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  {health.length === 0 ? (
                    <div className='sub-not-con'>
                      {' '}
                      <h6 className='sub-not'>Not Provided</h6>
                    </div>
                  ) : (
                    health.map((item, index) => (
                      <div className='bank-details line' key={index}>
                        <div className='icon-head'>
                          <div className='first'>
                            <div className='small-circle'>
                              <span>
                                {item.fullName
                                  .split(' ')
                                  .map((n) => n[0])
                                  .join('')}
                              </span>{' '}
                            </div>
                            <div>
                              <h6 className='sub'>{item.fullName}</h6>
                              <h6 className='sub pt-2'>{item.relationship}</h6>
                            </div>
                          </div>
                        </div>
                        <div className='others mb-2 pt-2'>
                          <div className='group'>
                            <span className='text-muted'>Date of Birth</span>{' '}
                            <span className='text-unmuted'>
                              {`${AgeFormmatter(item.dateOfBirth)} (Age: ${AgeValidator(item.dateOfBirth)})`}
                            </span>
                          </div>
                          <div className='group'>
                            <span className='text-muted'>Phone Number</span>{' '}
                            <span className='text-unmuted'>{item.phoneNumber}</span>
                          </div>
                          <div className='group'>
                            <span className='text-muted'>Email</span>{' '}
                            <span className='text-unmuted'>{item.email}</span>
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
                <div className='mb-3 profile-action'>
                  <button disabled className='not-allowed' onClick={handleAdd}>
                    {' '}
                    <span className='me-2 fs-5'>+</span> Add Dependent
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <ModalWrapper
        showModal={showModal}
        closeModal={toggleModal}
        title={<span className='custom-modal-title'> Add Dependent</span>}
      >
        <HealthUpdate
          toggleModal={toggleModal}
          health={health}
          setHealth={setHealth}
          selectedHealth={selectedHealth}
          editingIndex={editingIndex}
        ></HealthUpdate>
      </ModalWrapper>
    </div>
  )
}

export default HealthInfo
